module.exports = __webpack_public_path__ + "img/delivering-trust.0be12598.png";